export function readStorageFlag(key: string | null): boolean {
  if (!key) return false;
  try {
    return !!localStorage.getItem(key);
  } catch {
    return false;
  }
}

export function writeStorageFlag(key: string | null): void {
  if (!key) return;
  try {
    localStorage.setItem(key, new Date().toISOString());
  } catch {
    // localStorage unavailable — non-fatal
  }
}
